<template>
  <div>
    <div class="mobile">
      <section class="m-hero">
        <h1>Switcher</h1>
        <p>
          이제 누워서 불 끄세요
          <br>Switcher로 가능합니다
        </p>
      </section>
      <section class="m-switcher-description-first">
        <div class="m-description-container">
          <span>
            불 끄는 스위치가
            <br>머리맡에 있다면 어떨까요
          </span>
          <p class="detail-description">
            불을 끄고 잘까. 불을 켜고 잘까.
            <br>잘 때마다 고민한 적 있나요?
            <br>이젠 이불 밖으로 나가지 말고 스위처
            <br>앱으로 누워서 불을 꺼보세요.
            <br>Bluetooth로 반경 30미터 내에서
            <br>원격 조정이 가능합니다.
          </p>
        </div>
        <img style="width: 112px;" src="@/assets/switch.gif">
      </section>
      <section class="m-switcher-description-youtube">
        <div class="video-wrapper">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer-switcher"
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/9MbBFuTL4eU"
            frameborder="0"
          />
        </div>
      </section>
      <section class="m-switcher-description-second">
        <div class="m-description-container">
          <span>
            불 켜진 집에 들어오는
            <br>기분이 꽤 좋아요
          </span>
          <p class="detail-description">
            캄캄한 방에서 스위치를 찾을 땐
            <br>어둠 속에 갇힌 기분이 들곤하죠.
            <br>스위처로 점등, 소등 시간을 예약해보세요.
            <br>따뜻한 조명이 반겨주는 집을 상상하면
            <br>발걸음이 한결 가벼워질 거예요.
          </p>
        </div>
      </section>
      <section class="m-switcher-description-third">
        <div class="m-description-container">
          <span>내 방과의 조화를 생각하며</span>
          <p class="detail-description">
            무광 화이트와 그레이 컬러의 조합,
            <br>부드러운 곡선을 살린 미니멀한
            <br>디자인으로 어떤 공간에 있어도
            <br>잘 어울립니다. 심플한 외관으로
            <br>오랫동안 사용해도 질리지 않아요.
          </p>
        </div>
      </section>
      <section class="m-switcher-description-fourth"></section>
      <section class="m-switcher-description-fifth">
        <div class="m-description-container">
          <span>
            누구의 도움도 없이
            <br>붙이기만 하면 끝
          </span>
          <p class="detail-description">
            특수 소재 벨크로를 사용하던 스위치 위에
            <br>붙이면 1분 만에 설치가 끝납니다.
            <br>공구나 배선 시공도 필요없죠. 이사를 가도,
            <br>위치를 바꿔도 흔적이 남지 않아요.
            <br>
            <br>
          </p>
        </div>
      </section>
      <section class="m-switcher-description-reservation">
        <div class="m-description-container">
          <span>다양한 활용이 가능한 어플리케이션</span>
          <p class="m-detail-description">
            아이오 앱으로 스위처의 여러기능들을
            <br>더욱 편리하게 사용할 수 있습니다.
            <br>점등과 소등의 예약 설정은 물론,
            <br>평일, 주말, 일일 단위의 기간 설정까지.
          </p>
          <img
            style="position: absolute; bottom: 0; left: 50%; transform: translate(-50%); width: 230px;"
            src="@/assets/switcher/m-switcher-reservation-ui.png"
            alt
          >
        </div>
      </section>
      <section class="m-switcher-description-sixth">
        <div class="m-description-container">
          <span>
            Switcher는 앱에서
            <br>컨트롤 할 수 있어요
            <br>앱을 다운받으면 휴대폰으로
            <br>원격 제어, 예약 제어가 가능합니다
          </span>
          <div class="button-wrapper">
            <a
              href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
              target="_blank"
            >
              <div class="app-button">
                <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
                <span style="font-size: 14px">App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
              target="_blank"
              class="hideAll"
            >
              <div class="app-button">
                <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
                <span style="font-size: 14px">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section class="m-switcher-description-seventh">
        <div class="m-description-container">
          <span>배터리 충전도 확인도 간단히</span>
          <p class="detail-description">
            3시간만 충전하면 40일 동안 사용
            <br>가능합니다. 안드로이드 5핀 케이블만
            <br>있으면 어디서나 충전이 가능하죠.
            <br>배터리 용량은 앱에서 확인 가능합니다.
          </p>
        </div>
      </section>
      <section class="m-switcher-description-eighth">
        <div class="m-description-container">
          <span>
            Linker와 함께라면 더 좋은 Switcher,
            <br>어디서든 전등을 껐다 켰다
          </span>
          <div>
            <span>
              링커와 스위처를 함께 사용하면
              <br>Bluetooth가 닿지 않는 집 밖에서도
              <br>Wi-Fi로 언제든 불을 켜고 끌 수 있어요.
            </span>
          </div>
          <div class="go-linker-button" @click="goLinker">
            <span>Linker 바로가기</span>
          </div>
        </div>
      </section>
      <section class="m-usecase">
        <div class="m-usecase-container">
          <h1>
            Switcher 이렇게
            <br>활용해 보세요
          </h1>
          <div class="m-usecase-contents">
            <span>나의 소중한 숙면을 위해 사용해요</span>
            <p>
              자동 점등 기능을 사용해보세요.
              <br>자야 할 시간엔 알아서 불을 꺼주고,
              <br>일어날 시간엔 밝은 불빛으로
              <br>조용한 아침을 시작할 수 있습니다.
            </p>
          </div>
          <div class="m-usecase-contents">
            <span>명절에도, 휴가철에도 내 방을 관리하세요</span>
            <p>
              문단속은 필수죠, 우편물 관리도요.
              <br>거기에 초저녁에 맞춰 점등까지
              <br>예약한다면 빈집털이에
              <br>대비해 철저한 준비 완료입니다.
            </p>
          </div>
          <div class="m-usecase-contents">
            <span>
              어두운 방에 홀로 있을
              <br>그 혹은 그녀를 위해 사용하세요
            </span>
            <p>
              반려동물, 반려식물과 함께 살고 있다면
              <br>점등, 소등 시간을 예약해보세요.
              <br>나뿐만 아니라 그들의 삶의 질도 올라갈 거에요.
            </p>
          </div>
          <div class="m-usecase-contents">
            <span>
              여러 사람이 함께
              <br>여러 개의 스위처를 제어하세요
            </span>
            <p>
              이미 집에 한 개의 스위처가 있다면
              <br>여러 대의 스마트폰에 등록해보세요.
              <br>누군가 깜빡 잊고 불을 끄지 않았다면
              <br>스위처 앱에서 대신 꺼줄 수 있어요.
              <br>방마다 스위처를 설치했다면
              <br>한 대의 스마트폰으로 제어해
              <br>불필요한 전기를 줄일 수 있죠.
            </p>
          </div>
        </div>
      </section>
    </div>
    <div class="desktop">
      <section>
        <div class="hero">
          <div class="main-title-container">
            <span>
              이제 누워서 불 끄세요
              <br>Switcher로 가능합니다
            </span>
          </div>
        </div>
      </section>
      <section class="switcher-description-first">
        <div>
          <span class="description-title">불 끄는 스위치가 머리맡에 있다면 어떨까요</span>
          <p class="description-subtitle">
            불을 끄고 잘까. 불을 켜고 잘까. 잘 때마다 고민한 적 있나요?
            <br>이젠 이불 밖으로 나가지 말고 스위처 앱으로 누워서 불을 꺼주세요.
            <br>Bluetooth로 반경 30미터 내에서 원격 조정이 가능합니다.
          </p>
          <img style="width: 112px;" src="@/assets/switch.gif">
        </div>
      </section>
      <section class="switcher-description-youtube">
        <div class="video-wrapper">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer-switcher"
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/9MbBFuTL4eU"
            frameborder="0"
          />
        </div>
      </section>
      <section class="switcher-description-second">
        <div class="description-container">
          <span class="description-title">불 켜진 집에 들어오는 기분이 꽤 좋아요</span>
          <p class="description-subtitle">
            캄캄한 방에서 스위치를 찾을 땐 어둠 속에 갇힌 기분이 들곤하죠.
            <br>스위처로 점등, 소등 시간을 예약해보세요.
            <br>따뜻한 조명이 반겨주는 집을 상상하면 발걸음이 한결 가벼워질 거예요.
          </p>
        </div>
      </section>
      <section class="switcher-description-third">
        <div class="description-container">
          <span class="description-title">내 방과의 조화를 생각하며</span>
          <p class="description-subtitle">
            무광 화이트와 그레이 컬러의 조합,
            <br>부드러운 곡선을 살린 미니멀한 디자인으로
            <br>어떤 공간에 있어도 잘 어울립니다.
            <br>심플한 외관으로 오랫동안 사용해도 질리지 않아요.
          </p>
        </div>
      </section>
      <section class="switcher-description-fourth">
        <div class="description-container">
          <span class="description-title">누구의 도움도 없이 붙이기만 하면 끝</span>
          <p class="description-subtitle">
            특수 소재 벨크로를 사용하던 스위치 위에 붙이면
            <br>1분 만에 설치가 끝납니다. 공구나 배선 시공도 필요없죠.
            <br>이사를 가도, 위치를 바꿔도 흔적이 남지 않아요.
          </p>
        </div>
      </section>
      <section class="switcher-description-reservation">
        <div class="description-container">
          <span class="description-title">다양한 활용이 가능한 어플리케이션</span>
          <p class="description-subtitle">
            아이오 앱으로 스위처의 여러 기능들을 더욱 편리하게 사용할 수 있습니다.
            <br>점등과 소등의 예약 설정은 물론, 평일, 주말, 일일 단위의 기간 설정까지.
          </p>
          <img
            style="width: 370px; margin-top: 50px;"
            src="@/assets/switcher/switcher-reservation-ui.png"
            alt
          >
        </div>
      </section>
      <section class="switcher-description-fifth">
        <div>
          <span>
            Switcher는 전용 앱에서 컨트롤 할 수 있어요
            <br>앱을 다운받으면 휴대폰으로 원격 제어, 예약 제어가 가능합니다
          </span>
        </div>
        <div class="button-wrapper">
          <a
            href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
            target="_blank"
          >
            <div class="app-button">
              <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
              <span>App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
            target="_blank"
            class="hideAll"
          >
            <div class="app-button">
              <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
              <span>Google Play</span>
            </div>
          </a>
        </div>
      </section>
      <section class="switcher-description-sixth">
        <div class="description-container">
          <span class="description-title">배터리 충전도 확인도 간단히</span>
          <p class="description-subtitle">
            3시간만 충전하면 40일 동안 사용 가능합니다.
            <br>안드로이드 5핀 케이블만 있으면 어디서나 충전이 가능하죠.
            <br>배터리 용량은 앱에서 확인 가능합니다.
          </p>
        </div>
      </section>
      <section class="switcher-description-seventh">
        <div>
          <p class="linker-title">Linker와 함께라면 더 좋은 Switcher, 어디서든 전등을 껐다 켰다</p>
          <p
            class="linker-subtitle"
          >링커와 스위처를 함께 사용하면 Bluetooth가 닿지 않는 집 밖에서도 Wi-Fi로 언제든 불을 켜고 끌 수 있어요.</p>
          <div @click="goLinker" class="go-linker" style="cursor: pointer">Linker 바로가기</div>
        </div>
      </section>
      <section class="switcher-description-eighth">
        <div>
          <span class="usecase-title">
            Switcher 이렇게
            <br>활용해 보세요
          </span>
        </div>
        <div class="usecase-wrapper">
          <div class="usecase-contents" style="margin: 0">
            <span>나의 소중한 숙면을 위해 사용해요</span>
            <p>
              자동 점등 기능을 사용해보세요. 자야 할 시간엔 알아서 불을 꺼주고,
              <br>일어날 시간엔 밝은 불빛으로 조용한 아침을 시작할 수 있습니다.
            </p>
          </div>
          <div class="usecase-contents">
            <span>명절에도, 휴가철에도 내 방을 관리하세요</span>
            <p>
              문단속은 필수죠. 우편물 관리도요. 거기에 초저녁에 맞춰 점등까지
              <br>예약한다면 빈집털이에 대비해 철저한 준비 완료입니다.
            </p>
          </div>
          <div class="usecase-contents">
            <span>어두운 방에 홀로 있을 그 혹은 그녀를 위해 사용하세요</span>
            <p>
              반려동물, 반려식물과 함께 살고 있다면 점등, 소등 시간을 예약해보세요.
              <br>나뿐만 아니라 그들의 삶의 질도 올라갈 거에요.
            </p>
          </div>
          <div class="usecase-contents">
            <span>여러 사람이 함께 여러 개의 스위처를 제어하세요</span>
            <p>
              이미 집에 한 개의 스위처가 있다면 여러 대의 스마트폰에 등록해보세요.
              <br>누군가 깜빡 잊고 불을 끄지 않았다면 스위처 앱에서 대신 꺼줄 수 있어요.
              <br>방마다 스위처를 설치했다면 한 대의 스마트폰으로 제어해 불필요한 전기를 줄일 수 있죠.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'switcher-summary',
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    goLinker: function () {
      this.$router.push({ 'name': 'Linker' })
    },
    playBtnClick: function () {
      this.isPlaying = true
    }
  }
}
</script>
<style scoped>
.apply {
  padding: 10px 19px;
  position: relative;
  vertical-align: middle;
  font-family: "Noto Sans KR", sans-serif;
  letter-spacing: -0.4px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  border-radius: 2px;
  background-color: #6f97fa;
  text-decoration: none;
  display: inline-block;
  border: 0;
  outline: 0;
}

.modal-container {
  display: flex;
  padding: 40px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  border: solid 1px #dee2e5;
}
.modal-container div span {
  margin-left: 19px;
}

.m-hero {
  background: url("../../../assets/m-img-switcher.png") no-repeat center center;
  background-size: cover;
  min-height: 470px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}

.m-hero h1 {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
}

.m-hero p {
  margin: 23px 0px 0px 0px;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 1.56;
}
.m-description-container {
  text-align: left;
}
.m-description-container span {
  font-size: 18px;
  line-height: 1.56;
}

.description-container {
  text-align: left;
}
.m-switcher-description-first {
  width: 100%;
  min-height: 480px;
  padding: 41px 0px 0px 26px;
}

.description-container span {
  font-size: 24px;
  line-height: 1.56;
  letter-spacing: 0;
}

.m-switcher-description-reservation {
  height: 578px;
  background-color: #fafafa;
  padding-top: 91px;
  position: relative;
}
.m-switcher-description-reservation .m-description-container {
  text-align: center;
}
.m-switcher-description-reservation .m-description-container span {
  font-size: 18px;
}
.m-switcher-description-reservation .m-detail-description {
  font-size: 14px;
  line-height: 1.71;
  margin-top: 12px;
}
.m-switcher-description-first img {
  margin-right: 26px;
  margin-top: 45px;
}
.m-switcher-description-second {
  background: url("../../../assets/main/m-img-switcher-second.png") no-repeat
    center center;
  background-size: cover;
  min-height: 548px;
  padding: 79px 0px 0px 26px;
}
.m-switcher-description-third {
  padding: 72px 0px 54px 26px;
}
.m-switcher-description-fourth {
  background: url("../../../assets/main/m-img-switcher-fourth.png") no-repeat center center;
  background-size: cover;
  min-height: 254px;
}
.m-switcher-description-fifth {
  background: url("../../../assets/main/m-img-switcher-fifth.png") no-repeat
    center bottom;
  background-size: cover;
  min-height: 560px;
  padding: 50px 0px 0px 26px;
}
/* iPhone 6,7,8 */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .m-switcher-description-fifth {
    padding: 40px 0px 0px 26px;
  }
}
.m-switcher-description-sixth {
  min-height: 497px;
}

.m-switcher-description-sixth .m-description-container {
  text-align: center;
  padding: 110px 0px 0px 0px;
}

.m-switcher-description-seventh {
  background: url("../../../assets/main/m-img-switcher-seventh.png") no-repeat
    center center;
  background-size: cover;
  min-height: 480px;
  padding: 72px 0px 0px 26px;
}
.m-switcher-description-eighth {
  background: url("../../../assets/main/m-img-switcher-eighth.png") no-repeat
    center bottom;
  background-size: cover;
  min-height: 558px;
  padding: 70px 0px 0px 0px;
}
.m-switcher-description-eighth .m-description-container {
  text-align: center;
  color: #ffffff;
}
.m-switcher-description-eighth .m-description-container div {
  line-height: 1.71;
  margin-top: 26px;
}

.m-switcher-description-eighth .m-description-container div span {
  font-size: 14px;
}

.m-switcher-description-youtube {
  height: 300px;
  display: flex;
  justify-content: center;
}

.m-switcher-description-youtube .video-wrapper {
  position: relative;
  width: 90%;
  height: 80%;
}

.m-switcher-description-youtube .video-wrapper .video-cover {
  background: url("../../../assets/switcher/switcher_youtube_cover.png") no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.play-icon {
  background: url("../../../assets/linker/play-btn.png") no-repeat center;
  background-size: cover;
  width: 60px;
  height: 60px;
  opacity: 1;
}
#ytplayer-switcher {
  width: 100%;
  height: 100%;
}
.removeCover {
  display: none !important;
}
.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-button:hover {
  border: solid 1px #3d4953;
}
.app-button img {
  margin-right: 7px;
}
.button-wrapper {
  margin-top: 36px;
  display: inline-block;
}
.button-wrapper a:hover {
  text-decoration: none;
}
.button-wrapper div {
  margin: 7px;
  color: #3d4953 !important;
}
.go-linker-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: center;
  margin: 0 auto;
}
.detail-description {
  margin: 23px 0px 0px 0px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
}
.usecase {
  background-color: #fafafa;
  padding: 73px 0px 110px 25px;
}

.usecase-container {
  text-align: left;
}
.usecase-container span {
  line-height: 1.56;
}

.usecase-contents {
  font-size: 16px;
  line-height: 1.71;
  margin-top: 39px;
}
.usecase-contents span {
  font-weight: bold;
}
.usecase-contents p {
  margin-top: 9px;
}
.usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}
.m-usecase {
  background-color: #fafafa;
  padding: 73px 0px 110px 25px;
}

.m-usecase-container {
  text-align: left;
}
.m-usecase-container h1 {
  font-size: 18px;
  line-height: 1.56;
}
.m-usecase-container span {
  line-height: 1.56;
}

.m-usecase-contents {
  font-size: 14px;
  line-height: 1.71;
  margin-top: 39px;
}
.m-usecase-contents span {
  font-weight: bold;
}
.m-usecase-contents p {
  margin-top: 9px;
}
.m-usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.desktop section {
  margin-bottom: 30px;
}

.main-title-container {
  text-align: left;
  margin-left: 10%;
}

.hero {
  background: url("../../../assets/main/switcher.png") no-repeat center center;
  background-size: cover;
  background-position: center;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.hero span {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.58;
  letter-spacing: 0;
}

.switcher-description-first {
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.switcher-description-first img {
  margin-top: 42px;
}

.description-title {
  font-size: 24px;
  font-weight: 500;
}
.description-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 13px;
}

.switcher-description-youtube {
  min-height: 654px;
  display: flex;
  justify-content: center;
}
.switcher-description-youtube .video-wrapper {
  position: relative;
  width: 80%;
}
.switcher-description-youtube .video-wrapper .video-cover {
  background: url("../../../assets/switcher/switcher_youtube_cover.png") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.switcher-description-youtube .video-wrapper .video-cover:hover .play-icon {
  opacity: 1;
}

.switcher-description-second {
  background: url("../../../assets/main/img-switcher-second.png") no-repeat
    center center;
  background-size: cover;
  min-height: 654px;
  padding: 91px 0px 0px 256px;
  text-align: left;
}

.switcher-description-third {
  background: url("../../../assets/main/img-switcher-third.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  flex-flow: row-reverse;
  align-items: center;
}

.switcher-description-third div {
  flex: 0.45;
}

.switcher-description-fourth {
  background: url("../../../assets/main/img-switcher-fourth.png") no-repeat
    center center;
  background-size: cover;
  min-height: 610px;
  display: flex;
  align-items: center;
}
.switcher-description-fourth div {
  margin-left: 264px;
}
.switcher-description-reservation {
  position: relative;
  background-color: #fafafa;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.switcher-description-reservation .description-container {
  text-align: center;
}
.switcher-description-fifth {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  width: 100%;
}
.switcher-description-fifth span {
  font-size: 20px;
  line-height: 1.7;
}
.switcher-description-fifth .button-wrapper {
  display: flex;
}
.switcher-description-fifth .button-wrapper span {
  font-size: 16px;
}
.switcher-description-sixth {
  background: url("../../../assets/main/img-switcher-sixth.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.switcher-description-sixth div {
  margin-left: 264px;
}
.switcher-description-seventh {
  background: url("../../../assets/main/img-switcher-seventh.png") no-repeat
    center bottom;
  background-size: cover;
  min-height: 700px;
  display: flex;
  justify-content: center;
}
.switcher-description-seventh div {
  text-align: center;
  margin-top: 131px;
}
.switcher-description-seventh .linker-title {
  font-size: 24px;
  color: #ffffff;
  font-weight: 500;
}
.switcher-description-seventh .linker-subtitle {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
.switcher-description-seventh .go-linker {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px rgba(114, 114, 114, 100);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 27px auto;
}

.switcher-description-seventh .go-linker:hover {
  border: solid 1px #ffffff;
}

.desktop .usecase-contents {
  text-align: left;
}
.desktop .usecase-contents p {
  font-weight: 400;
}
.switcher-description-eighth {
  width: 100%;
  display: flex;
  background-color: #fafafa;
  justify-content: space-evenly;
  padding-top: 100px;
  padding-bottom: 100px;
}

.switcher-description-eighth div {
  text-align: left;
  font-weight: 500;
}

.switcher-description-eighth .usecase-title {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/products/switcher/SwitcherSummary.vue